import styled from 'styled-components'

const Text = styled('span')`
  color: rgba(255,255,255,0.85);
  font-size: 26px;
  font-weight: bold;
`

export default Text
